import Client from "@/app/repository/axios-client";

const resource = '/message/messages';

export default {
  getUrlForAddAttachmentToDraftMessage(messageId) {
    return Client.defaults.baseURL + `${resource}/${messageId}/attachment`;
  },
  addAttachmentToDraftMessage(payload, messageId) {
    return Client.post(`${resource}/${messageId}/attachment`, payload);
  },
  removeAttachmentFromDraftMessage(messageId, attachmentId, version) {
    return Client.delete(`${resource}/${messageId}/attachment/${attachmentId}?version=${version}`);
  },
  getAttachment(messageId, attachmentId) {
    return Client.get(`${resource}/${messageId}/attachment/${attachmentId}?base64=true`)
  },
  getReplyAttachment(messageId, replyId, attachmentId) {
    return Client.get(`${resource}/${messageId}/reply/${replyId}/attachment/${attachmentId}?base64=true`)
  },
}
